export function isValidInviteEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function isValidPhoneDigits(phoneNumber: string): boolean {
  return /^\d{10}$/.test(phoneNumber);
}

export function getInviteEmailError(email: string): string | undefined {
  const trimmed = email.trim();
  if (!trimmed) {
    return "Ingresa un correo electrónico.";
  }
  if (!isValidInviteEmail(trimmed)) {
    return "Ingresa un correo electrónico válido.";
  }
  return undefined;
}

export function getInvitePhoneError(phoneNumber: string): string | undefined {
  if (!phoneNumber) {
    return "Ingresa un teléfono de 10 dígitos.";
  }
  if (!isValidPhoneDigits(phoneNumber)) {
    return "El teléfono debe tener 10 dígitos.";
  }
  return undefined;
}
